import {AfterViewInit, Component, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {MatPaginator, PageEvent} from "@angular/material/paginator";
import {NgForm} from "@angular/forms";
import {ReplaySubject} from "rxjs";
import {UserPermissions} from "../../../../shared/interface/user-permissions";
import {LeaveApplication} from "../../../../shared/interface/employee";
import {MatDialog} from "@angular/material/dialog";
import {MatSnackBar} from "@angular/material/snack-bar";
import {AuthService} from "../../../../shared/services/auth.service";
import {ActivatedRoute, Router} from "@angular/router";
import {FilterService} from "../../../../shared/services/filter.service";
import {select, Store} from "@ngrx/store";
import {StoreRootState} from "../../../../shared/ngrx/reducers";
import {delay, distinctUntilChanged, first, takeUntil} from "rxjs/operators";
import {CountedAndPaginated} from "../../../../shared/interface/response/counted-and-paginated";
import {LeaveApplicationService} from "../../../../shared/services/leave-application.service";
import {getCurrentRouteState} from "../../../../shared/ngrx/selector";
import {RouterStateUrl} from "../../../../shared/ngrx/route-serializer";
import {HttpErrorResponse} from "@angular/common/http";
import {JobResultDialogComponent} from "../../../../shared/components/job-result-dialog/job-result-dialog.component";
import {Uuid} from "../../../../shared/interface/response/uuid";


@Component({
  selector: 'app-all-leave-application-list',
  templateUrl: './all-leave-application-list.component.html',
  styleUrls: ['./all-leave-application-list.component.scss']
})
export class AllLeaveApplicationListComponent implements OnInit,  AfterViewInit, OnDestroy  {
  @Input() statusKeys?: string[] = null;
  @Input() employeeId?: string = null;
  @Input() disableBreadcrumb = false;
  @Input() embeddedView = false;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('filtersForm') filtersForm: NgForm;

  initialFilters: any;
  displayedColumns: string[] = ['employyee', 'createdAt', 'type', 'status', 'start', 'day', 'actions'];
  dataSource: LeaveApplication[] = [];
  totalData = 0;
  userPermissions: ReplaySubject<UserPermissions>;


  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private leaveApplicationService: LeaveApplicationService,
    private dialog: MatDialog,
    private snack: MatSnackBar,
    private auth: AuthService,
    private activatedRoute: ActivatedRoute,
    private filterService: FilterService,
    private store: Store<StoreRootState>,
    private router: Router,
  ) {
    this.userPermissions = auth.getUserPermissions();
    this.leaveApplicationService.getleaveApplicationListSubject()
      .pipe(takeUntil(this.destroyed$))
      .subscribe((result: CountedAndPaginated<LeaveApplication>) => {
        this.dataSource = result.items;
        this.totalData = result.pagination.total;
      });
    this.parseFilters();

  }

  parseFilters(filters?: any): void {
    this.initialFilters = this.filterService.parseFiltersFromQueryParams({
      employee: 'string',
      type: 'int',
      status: 'int',
      gte$createdAt: 'date',
      lte$createdAt: 'date',
      startAt: 'date',
      endAt: 'date',
      day: 'int',
      employeeId: 'string',
      year: 'int',
      leaveType: 'string',
    }, filters);
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    this.activatedRoute.data
      .pipe(
        delay(0),
        first()
      )
      .subscribe((data: any) => {
        this.statusKeys = this.statusKeys ?? data.statusKeys ?? null;
        if (!this.embeddedView) {
        this.store
          .pipe(
            select(getCurrentRouteState),
            delay(0),
            distinctUntilChanged((prev: RouterStateUrl, curr: RouterStateUrl) => prev.url === curr.url),
            takeUntil(this.destroyed$),
          )
          .subscribe((state: RouterStateUrl) => {
            this.parseFilters(state.params);
            this.paginator.pageIndex = state.params.page;
            this.paginator.pageSize = state.params.pageSize;
            this.loadListData();
          })
        ;
        } else {
          this.loadListData();
        }
      });

    this.paginator.page
      .pipe(
        takeUntil(this.destroyed$)
      ).subscribe((event: PageEvent) => {
      if (this.embeddedView) {
        this.loadListData();
      } else {
        this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, this.filterService.parseFiltersToQueryParams({
          page: event.pageIndex,
          pageSize: event.pageSize,
          ...this.filtersForm.value
        })]);
      }
    });
  }

  filter(): void {
    // this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, this.filterService.parseFiltersToQueryParams({
    //   page: 0,
    //   pageSize: this.paginator.pageSize,
    //   ...this.filtersForm.value,
    // })]);

    if (this.embeddedView) {
      if (this.paginator.pageIndex === 0) {
        this.loadListData();
      } else {
        this.paginator.firstPage();
      }
    } else {
      if (this.paginator.pageIndex === 0) {
        this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, this.filterService.parseFiltersToQueryParams({
          page: this.paginator.pageIndex,
          pageSize: this.paginator.pageSize,
          ...this.filtersForm.value
        })]);
      } else {
        this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, this.filterService.parseFiltersToQueryParams({
          page: 0,
          pageSize: this.paginator.pageSize,
          ...this.filtersForm.value,
        })]);
      }
    }
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  buildFilters(): any {
    const filters = {...this.initialFilters};

    if (null !== this.statusKeys) {
      filters.statusKeys = this.statusKeys;
    }

    if (null !== this.employeeId) {
      filters.employeeId = this.employeeId;
    }

    return filters;
  }

  loadListData(): void {
    this.leaveApplicationService.loadList(this.paginator.pageIndex, this.paginator.pageSize, this.buildFilters());
  }

  resetFilters(): void {
    this.filtersForm.resetForm();
    if (this.embeddedView) {
      this.loadListData();
    } else {
      this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, {
        page: 0,
        pageSize: this.paginator.pageSize,
      }]);
    }
  }

  downloadReport(): void {
    this.leaveApplicationService.downloadReport(this.buildFilters())
      .subscribe((response: Uuid) => {
        this.dialog.open(JobResultDialogComponent, {
          disableClose: true,
          width: '500px',
          data: {jobId: response.uuid, showProgress: false},
        });
      }, (error: HttpErrorResponse) => {
        this.snack.open('Przy generowaniu raportu wystąpił błąd', error.status.toString(), {duration: 2000});
      });
  }

  downloadPdf(leaveApplication: LeaveApplication): void {
    this.leaveApplicationService.downloadCertificate(leaveApplication.uuid);
  }
}
